import { createFileRoute } from "@tanstack/react-router";
import ChannelLinkStatsContainer from "../components/ChannelLinkStatsContainer";

export const Route = createFileRoute("/channel-link-stats")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <ChannelLinkStatsContainer />
    </div>
  );
}
